import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { channels } from "@/mocks/siteData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[660px] md:min-h-[780px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20atmospheric%20scene%20of%20a%20faint%20glowing%20light%20beam%20cutting%20through%20deep%20teal%20fog%2C%20layered%20translucent%20vertical%20panels%2C%20warm%20amber%20rim%20glow%2C%20cinematic%20minimal%20composition%20with%20wide%20negative%20space%2C%20high%20contrast%2C%20no%20text%2C%20no%20people%2C%20editorial%20poster%20art&width=1600&height=900&seq=qs-hero-a1&orientation=landscape"
        alt="潜声投稿匿名爆料投稿平台首屏背景，象征线索穿透迷雾抵达编辑"
        title="潜声投稿 - 匿名爆料投稿平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/94 via-foreground-950/82 to-foreground-950/48"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-background-50/10 border border-background-50/20 text-accent-300 text-xs tracking-[0.2em]">
                <i className="ri-shield-keyhole-line"></i>
                匿名爆料投稿 · 隐私优先
              </span>
            </Reveal>

            <Reveal delay={80}>
              <h2 className="mt-7 font-heading text-3xl md:text-[3.25rem] font-bold text-background-50 leading-[1.2]">
                想爆料却找不到门路？
                <br />
                把线索交到<span className="text-accent-300">对的人</span>手里。
              </h2>
            </Reveal>

            <Reveal delay={160}>
              <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-background-200">
                无论是一段文字、一张截图，还是一段视频、一份录音，这里都有对应的匿名通道。保护隐私的前提下，
                让你的线索快速直达编辑，安全发声不必孤军奋战。
              </p>
            </Reveal>

            <Reveal delay={240}>
              <div className="mt-9 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/channels"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-accent-500 text-foreground-950 font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i>
                  选择投稿通道
                </Link>
                <Link
                  to="/guide"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-50/25 text-background-50 font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-book-read-line"></i>
                  查看安全投稿指南
                </Link>
              </div>
            </Reveal>

            <Reveal delay={320}>
              <div className="mt-9 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-background-300">
                <span className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  无需注册与实名
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  加密通道传输
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  素材统一脱敏
                </span>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={200}>
              <div className="rounded-lg border border-background-50/15 bg-foreground-950/40 backdrop-blur-sm p-6 md:p-7">
                <div className="flex items-center justify-between">
                  <h3 className="m-0 font-heading text-lg font-semibold text-background-50">
                    四类投稿通道
                  </h3>
                  <span className="text-xs text-background-400">按素材类型选择</span>
                </div>
                <ul className="mt-5 space-y-2.5">
                  {channels.map((channel) => (
                    <li key={channel.id}>
                      <Link
                        to={`/channels#${channel.slug}`}
                        className="flex items-center gap-3.5 px-3.5 py-3 rounded-md border border-background-50/10 bg-background-50/5 hover:bg-background-50/10 hover:border-accent-400/40 transition-colors group cursor-pointer"
                      >
                        <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-300 text-lg">
                          <i className={channel.icon}></i>
                        </span>
                        <span className="min-w-0 flex-1">
                          <span className="block text-sm font-medium text-background-50">
                            {channel.name}
                          </span>
                          <span className="block text-xs text-background-400 mt-0.5 truncate">
                            {channel.short}
                          </span>
                        </span>
                        <i className="ri-arrow-right-line text-background-400 group-hover:text-accent-300 transition-colors"></i>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}